<div class="loader loader-{{size}}">
  <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
</div>
